module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_2250_Active@1x-f128a091a81b936fdb59331560ed56da.png";